import React, { useState } from "react";
import { api } from "../../../helpers/api";
import { ShowToast } from "../../../components/toast";
import { Button } from "../../../components/Button";
import { PopupModal } from "../../../components/PopupModal";

export function ConfirmDelete({
  onClose,
  userId,
  refetch,
  name,
}: {
  onClose: () => void;
  userId: string;
  refetch: () => void;
  name: string;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const handleDelete = () => {
    setIsLoading(true);
    api
      .deletePlaylist(userId)
      .then(() => {
        onClose();
        ShowToast({
          message: "Playlist deleted successfully",
          type: "success",
        });
        refetch && refetch();
        setIsLoading(false);
      })
      .catch(() => {
        ShowToast({
          message: "Failed to delete playlist",
          type: "error",
        });
        setIsLoading(false);
      });
  };

  return (
    <PopupModal
      onClose={onClose}
      contentClassName="w-[500px] mx-auto"
      open={true}
      showCloseButton={false}
    >
      <p className="text-lg leading-[28.8px] poppins">
        Are you sure you want to delete {name}? All of its data will be
        permanently removed.
      </p>
      <div className="flex flex-row gap-4 ml-auto">
        <Button variant="outline" className="px-8" onClick={onClose}>
          No, go back
        </Button>
        <Button
          className="px-8 text-[1rem] !bg-[#FDCDCD] !text-[#D30000]"
          onClick={handleDelete}
          loading={isLoading}
          variant="primary"
        >
          Yes delete
        </Button>
      </div>
    </PopupModal>
  );
}

export function ConfirmVideoDelete({
  playlist,
  onClose,
  videoId,
  refetch,
  name,
}: {
  playlist: any;
  onClose: () => void;
  videoId: any;
  refetch: () => void;
  name: string;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const handleDelete = () => {
    setIsLoading(true);
    let obj = {
      video_ids: playlist?.videos
        ?.filter((item) => item?.video_id != videoId)
        ?.map((item) => item?.video_id),
    };

    api
      .updatePlaylist(playlist?.playlist_id, obj)
      .then(() => {
        onClose();
        ShowToast({
          message: "Video deleted successfully",
          type: "success",
        });
        refetch && refetch();
        setIsLoading(false);
      })
      .catch(() => {
        ShowToast({
          message: "Failed to delete video",
          type: "error",
        });
        setIsLoading(false);
      });
  };

  return (
    <PopupModal
      onClose={onClose}
      contentClassName="w-[500px] mx-auto"
      open={true}
      showCloseButton={false}
    >
      <p className="text-lg leading-[28.8px] poppins">
        Are you sure you want to delete {name}? All of its data will be
        permanently removed.
      </p>
      <div className="flex flex-row gap-4 ml-auto">
        <Button variant="outline" className="px-8" onClick={onClose}>
          No, go back
        </Button>
        <Button
          className="px-8 text-[1rem] !bg-[#FDCDCD] !text-[#D30000]"
          onClick={handleDelete}
          loading={isLoading}
          variant="primary"
        >
          Yes delete
        </Button>
      </div>
    </PopupModal>
  );
}
